import * as React from 'react';
import moment from 'moment-timezone';
import { Spin } from 'antd';
import { useCommonInfoStore } from '@src/shared/store/common';
import { pageNavsStore } from '@src/shared/store/navs';
import {
  useUserInfo,
  useMetadataTimeRange,
  useDimensions,
  useAggregations,
  useCriticalEvents,
} from '@src/services/queries';
import ContactConviva from '@shared/components/ContactConviva';
import NavTabs from '@src/features/NavTabs';

interface InitCheckProps {
  children: React.ReactNode;
}

// TODO: Refactor to use react-query for state management
const { setTimeRange, setUserInfo } = useCommonInfoStore.getState();

const InitCheck = ({ children }: InitCheckProps) => {
  const { data: userInfo, isLoading: isUserInfoLoading, isError: isUserInfoError } = useUserInfo();
  const {
    data: metadataTimeRange,
    isLoading: isMetadataTimeRangeLoading,
    isError: isMetadataTimeRangeError,
  } = useMetadataTimeRange();
  const { isLoading: isAggregationsLoading } = useAggregations();
  const { isLoading: isDimensionsLoading } = useDimensions();
  const { isLoading: isCriticalEventsLoading } = useCriticalEvents();
  const [dashboardStoreRehydrated, setDashboardStoreRehydrated] = React.useState(false);

  React.useEffect(() => {
    if (userInfo?.tzName) {
      moment.tz.setDefault(userInfo.tzName);
    }

    if (userInfo) {
      setUserInfo(userInfo);
    }

    if (metadataTimeRange) {
      setTimeRange(metadataTimeRange);
    }

    if (userInfo?.customer_id) {
      pageNavsStore.persist.setOptions({
        name: `user_journey_dashboards:${userInfo.customer_id}`,
      });

      void (async () => {
        await pageNavsStore.persist.rehydrate();
        setDashboardStoreRehydrated(true);
      })();
    }
  }, [userInfo, metadataTimeRange]);

  if (
    isUserInfoError ||
    isMetadataTimeRangeError ||
    userInfo?.feature_flags?.['eco-user-journey'] === false
  ) {
    return <ContactConviva />;
  }

  if (
    isUserInfoLoading ||
    isMetadataTimeRangeLoading ||
    isAggregationsLoading ||
    isDimensionsLoading ||
    isCriticalEventsLoading ||
    !dashboardStoreRehydrated
  ) {
    return (
      <Spin
        style={{
          height: 'calc(100vh - 60px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    );
  }

  return (
    <div style={{ position: 'relative', padding: '0 3px' }}>
      <NavTabs />
      {children}
    </div>
  );
};

export default InitCheck;
